module.exports = __webpack_public_path__ + "static/media/5222.77405c01.jpg";